import { useCallback } from 'react';
import { useTrackEvent } from '$analytics/useTrackAnalytics/useTrackAnalytics';
import {
  ContactModalEventLabels,
  ContactModalEventMap,
  type TrackContactModalEvent,
} from './events';

export function useTrackContactModalAnalytics() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (event: TrackContactModalEvent, extra?: Record<string, unknown>) => {
      const eventLabel = ContactModalEventLabels[event];
      const eventInfo = ContactModalEventMap[event];
      trackEvent(eventLabel, {
        ...eventInfo,
        ...extra,
      });
    },
    [trackEvent],
  );
}
